var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"videoModel","hide-footer":""}},[_c('iframe',{attrs:{"id":"videoFrame","src":_vm.data.videoSrc,"width":"100%","height":"480","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }